import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  glow?: boolean;
}

export const Card = ({
  children,
  className,
  glow = false,
  ...props
}: CardProps) => {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-3xl p-8 transition-all duration-300",
        glow && "shadow-xl shadow-primary/10",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
